import { FC, useEffect, useState } from 'react'

import { ApolloProvider } from '@apollo/client'
import { useDispatch } from 'react-redux'
import { useAuthentication } from '@ecosystem/newron-client-lib'
import { setUserJwt } from 'reducers/user'
import { getApolloClientWithAuthentication } from 'query/client'

const ApolloWithAuth: FC = ({ children }) => {
  const { isAuthenticated, user, getAccessToken } = useAuthentication()
  const [token, setToken] = useState('')
  const dispatch = useDispatch()

  useEffect(() => {
    async function getToken() {
      // eslint-disable-next-line no-useless-catch
      try {
        if (isAuthenticated) {
          const atoken = (await getAccessToken()) || ''
          setToken(atoken)
          dispatch(setUserJwt(atoken))
        }
      } catch (e: any) {
        throw e
      }
    }
    getToken()
  }, [user, isAuthenticated, dispatch, getAccessToken])

  return isAuthenticated && token?.length ? (
    <ApolloProvider client={getApolloClientWithAuthentication(token)}>{children}</ApolloProvider>
  ) : null
}

export default ApolloWithAuth
